import { useEffect, useState } from 'react';

import { useRemoveTimeoutID } from '../../../actions/alert';
import { checkAlertEnabled, checkLanding, checkTakeOff, checkTodPoint } from '../../../service/alert/tools';

export const useDisableAlerts = ({ type, legId, allowed }) => {
    const removeTimeoutID = useRemoveTimeoutID();

    const isAlertEnabled = checkAlertEnabled({ allowed });
    const isTakeOff = checkTakeOff();
    const isTodPointAto = checkTodPoint();
    const isLanding = checkLanding();

    const shouldDisableAlerts = !isAlertEnabled || !isTakeOff || isTodPointAto || isLanding;
    const [disabled, setDisabled] = useState(shouldDisableAlerts);

    useEffect(() => {
        setDisabled(shouldDisableAlerts);

        if (shouldDisableAlerts || !allowed) {
            removeTimeoutID(legId, type);
        }
    }, [shouldDisableAlerts]);

    return disabled;
};
